import { validateString } from "@deliverr/ui-facility/lib-facility/utils/stringUtils";

const validPositiveInteger = /^\+?[0-9]+$/;

export const isValidPositiveInteger = validateString(validPositiveInteger);
